/*
 * @description:
 * @Author: liwg
 * @Date: 2022-07-13 19:57:28
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-08-26 10:13:41
 */

import { createRouter, createWebHistory } from 'vue-router'
import { isString } from '@ns/utils'
import { omit } from 'lodash-es'
import { evaLoginByCode, getUserInfo, loginByAuto } from '@/api/login'
import { getAppEnvConfig } from '@/utils/env'
import { iamLogin } from '@/utils/nhIam'
import { smSelf } from '@/utils/sm'
import { useUserStoreWithOut } from '@/store/user'
import { removeFaviconAndTitle } from '@/utils/dom'
import { constantRouter } from './constant-route'

import type { App } from 'vue'
const { createErrorModal, createMessage } = useMessage()
const { shortName, isEhome, isNhxm, oauthFlag } = getAppEnvConfig()
export const router = createRouter({
  history: createWebHistory(`/${shortName}`),
  routes: constantRouter,
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 })
})

const whiteList = [
  'login',
  'findPassword',
  'customLogin',
  'paperConfig',
  'baoming',
  'feedback',
  'privacyPolicy',
  'nmLogin',
  'bszh',
  'aliyunUploadTest'
]
const routeHistoryList: any = []
router.beforeEach(async (to, _from, next) => {
  to.meta.from = _from
  routeHistoryList.push(to.name)
  const userStore = useUserStoreWithOut()
  //如果是简洁登录页 删除页面的title
  if (['nmLogin', 'bszh'].includes(to.name as string) || userStore.isPureLoginPage) {
    removeFaviconAndTitle()
  }
  const { loginSuccess } = userStore
  if (isString(to.name) && to.name.toLowerCase().includes('login') && to.query.key) {
    const data = await loginByAuto({
      key: to.query.key as string,
      ocLoginTerminal: 'pc'
    })
    data.login_type = 'auto'
    loginSuccess(data, to, false)
    //临时这样处理 不一定有测评列表
    next({
      name: 'evaluation',
      replace: true
    })
  }
  if (isEhome && routeHistoryList.length === 1) {
    // 当是南航e家打开的第一个页面时
    const resData = await window.ehome?.getAccountMessage({ isEncrypted: '1' })
    const data: any = await getUserInfo(resData.data || resData)
    if (data.msg) {
      createMessage.warning(data.msg)
    }
    loginSuccess(
      {
        access_token: data.access_token,
        userInfo: {
          name: data.name,
          staffCode: data.username,
          id: data.user_id
        },
        user_id: data.user_id,
        username: data.username,
        staffType: data.staffType,
        login_type: 'ehome'
      },
      to,
      false
    )
    next()
  } else if (isNhxm && to.query.code) {
    // 校验唯一设备
    const randomHash = localStorage.getItem('randomHash')
    if (!randomHash || !to.query.state || to.query.state !== smSelf.decryptBySm2(randomHash)) {
      createErrorModal({
        title: '错误提示',
        content: () => '您的账户检测到异常登录,为了您的账户安全，请重新登录并验证您的身份'
      })
    } else {
      // 南航网页版统一认证
      evaLoginByCode({ code: to.query.code })
        .then((data) => {
          if (data.msg) {
            createMessage.warning(data.msg)
          }
          loginSuccess(
            {
              access_token: data.access_token,
              userInfo: {
                name: data.name,
                staffCode: data.staffCode,
                id: data.user_id
              },
              user_id: data.user_id,
              username: data.username,
              staffType: data.staffType,
              login_type: 'ehome'
            },
            to,
            false
          )
          next({
            name: 'evaluation',
            replace: true
          })
        })
        .catch(() => {
          next()
        })
    }
  } else if (userStore.token) {
    if (isString(to.name) && to.name.toLowerCase().includes('login')) {
      next({
        name: 'evaluation',
        replace: true
      })
    } else {
      next()
    }
  } else if (isNhxm && oauthFlag && to.name !== 'customLogin') {
    // 网页版本统一认证
    iamLogin()
  } else if (to.name && whiteList.includes(to.name as string)) {
    next()
  } else {
    const { loginPageParams } = useUserStore()
    const { query = {}, params = {}, name = 'login' } = unref(loginPageParams)
    next({ name, params, query: omit(query, 'key') })
  }
})

export function setupRouter(app: App<Element>) {
  app.use(router)
}
